import { Tab } from '@atlassian/home-tab-selector/types';

import localStorageFacade from '@townsquare/facade/local-storage';

const LOCAL_STORAGE_KEY = 'tabs-whats-next';

export const getDefaultTabKey = (): string | null => {
	return localStorageFacade.getItem(LOCAL_STORAGE_KEY);
};

export const getDefaultTabIndex = (tabs: Tab[]): number => {
	const defaultTabKey = getDefaultTabKey();

	return Math.max(
		0,
		tabs.findIndex((tab) => tab.key === defaultTabKey),
	);
};

export const setTabInLocalStorage = (tabKey: string): void => {
	localStorageFacade.setItem(LOCAL_STORAGE_KEY, tabKey);
};
